var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowGuide
    ? _c(
        "div",
        { staticClass: "beginner-guide", class: _vm.$i18n.locale },
        [
          _vm.guideType === "assets"
            ? _c("div", { staticClass: "assets-back" }, [
                _c("div", { staticClass: "item assets" }, [
                  _c(
                    "div",
                    {
                      staticClass: "close __pointer",
                      on: {
                        mouseenter: _vm.overClose,
                        mouseleave: _vm.leaveClose,
                        click: _vm.close
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowTips,
                              expression: "isShowTips"
                            }
                          ],
                          staticClass: "tips"
                        },
                        [_vm._v(_vm._s(_vm.$t("guide.closeTips")))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content" },
                    _vm._l(_vm.$t("guide." + _vm.guideType), function(item, i) {
                      return _c("span", { key: i }, [
                        _vm._v(_vm._s(item)),
                        _c("br")
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "next-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass: "next __pointer",
                        on: { click: _vm.close }
                      },
                      [_vm._v(_vm._s(_vm.$t("guide.close")))]
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.$t("guide." + _vm.guideType), function(item, i) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.guideType === "trade" && _vm.guideStep === i,
                    expression: "guideType === 'trade' && guideStep === i"
                  }
                ],
                key: i,
                staticClass: "item trade",
                class: _vm.guideType
              },
              [
                _vm.guideType
                  ? _c("div", { staticClass: "icon" }, [
                      i === 1 && _vm.guideType === "trade"
                        ? _c("div", [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("tradeOpenOrders.title")))
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("tradeOrderHistory.title")))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      i === 2 && _vm.guideType === "trade"
                        ? _c("div", [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("tradeMining.title")))
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("tradeDividend.title")))
                            ])
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "close __pointer",
                    on: {
                      mouseenter: _vm.overClose,
                      mouseleave: _vm.leaveClose,
                      click: _vm.close
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTips,
                            expression: "isShowTips"
                          }
                        ],
                        staticClass: "tips"
                      },
                      [_vm._v(_vm._s(_vm.$t("guide.closeTips")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [_vm._v(_vm._s(item))]),
                _vm._v(" "),
                _c("div", { staticClass: "next-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "next __pointer", on: { click: _vm.next } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            i === _vm.$t("guide." + _vm.guideType).length - 1
                              ? _vm.$t("guide.close")
                              : _vm.$t("guide.next")
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ])
              ]
            )
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }